export enum InputType {
  FILE = 'file',
  TEXT = 'text',
}

export enum FormStep {
  UPLOAD = 'upload',
  VARIABLES = 'variables',
  INDUSTRIES = 'industries',
  COUNTRIES = 'countries',
}

export enum StepLabel {
  FILES = 'files',
  VARIABLES = 'variables',
  INDUSTRIES = 'industries',
  COUNTRIES = 'countries',
}

export enum StepSummaryLabel {
  SELECTED = 'selected',
  UPLOADED = 'uploaded',
}

export interface IStepper {
  id: number;
  label: StepLabel;
  summaryLabel: StepSummaryLabel;
}

export interface IStepInput {
  type: InputType;
  name: string;
  placeholder?: string;
}

export interface IStepCardData {
  title: string;
  description: string;
  input: IStepInput;
}

export type IStepData = Record<FormStep, IStepCardData>;
